import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ErrorLayer from "../components/ErrorLayer";


const ErrorPage = () => {
  return (
    <>
      {/* Breadcrumb */}
      <Breadcrumb title="404" />

      {/* ErrorLayer */}
      <ErrorLayer />
    </>
  );
};

export default ErrorPage;
